import { Component, Prop } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';

@Component({
  name: 'bpc-display-field-code',
  components: {},
})
export default class DisplayFieldCode extends mixins(AbstractDisplayField) {
  @Prop({ type: Boolean, default: true }) readonly clickable: boolean;
  get isRoleContact() {
    return (
      this.$authorizationService.hasRole('contact') ||
      this.$authorizationService.hasRole('contact_read')
    );
  }

  onClick() {
    if (!this.isRoleContact && this.clickable) {
      this.$emit('on-click', { field: this.fieldConfig.key, item: this.item });
    }
  }
}
